'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  max-width: 450px;
  flex: 1;
  display: flex;
  gap: 0.5rem;
  justify-content: stretch;
`;

export const search = css`
  flex: 1;
`;

export const input = css`
  && {
    background: ${theme.colors.neutral['5']};
    border-radius: 26px;
    box-shadow: none;
    &:placeholder-shown {
      text-overflow: ellipsis;
    }
  }
`;

export const item = css`
  display: flex;
  gap: 0.5rem;
`;

export const icon = css`
  color: ${theme.colors.neutral['3']};
`;

export const add = css`
  &&& {
    box-shadow: 0px 0px 14.1px -2px rgba(195, 203, 217, 0.4);
    border-width: 0;
    background: ${theme.gradients.peoople};
    background-clip: text;
    -webkit-text-fill-color: transparent;
    &:hover {
      background: ${theme.colors.peoople['azul-claro-medio']};
      color: white;
      background-clip: initial;
      -webkit-text-fill-color: initial;
    }
  }
`;

export const fullSize = css``;

export const resultList = css`
  max-height: 80vh;
  overflow-y: auto;
  min-width: 100%;
  max-width: 750px;
  width: calc(100vw - 2rem);
  padding: 0.5em;
  @media screen and (width > ${theme.sizes.screens.md}) {
    padding: 2em;
    max-height: 40vh;
  }
  &.${fullSize} {
    width: 80vw;
    max-height: 90vh;
    @media screen and (width > ${theme.sizes.screens.xl}) {
      width: 70vw;
      max-width: 900px;
    }
  }
`;

export const loading = css`
  width: 2rem;
  height: 2rem;
  display: blockquote;
  margin: 0.75rem auto;
`;

export const sectionTitle = css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  padding: 0.5rem;
  align-items: center;
  font-weight: 700;
  font-size: 18px;
  &:not(:first-child) {
    margin-top: 1rem;
  }
`;

export const itemTitle = css`
  font-size: 16px;
  font-weight: 700;
`;

export const itemSubtitle = css`
  font-size: 14;
  font-weight: 300;
  color: ${theme.colors.peoople['gris-medio-claro']};
`;
